import React from 'react';
import { StyleSheet, View } from 'react-native';
import Svg, { Defs, LinearGradient, Path, Stop, } from 'react-native-svg';
import { rem } from 'design-system';
import useColors from 'hooks/useColors';
const QuestsProgressIcon = ({ style, width = rem(58), height = rem(58), }) => {
    const colors = useColors();
    return (<View style={style}>
      <Svg width={width} height={height} viewBox="0 0 58 58" fill="none">
        <Path d="M29 1C10.0079 1 1 10.0079 1 29C1 47.9921 10.0079 57 29 57C47.9921 57 57 47.9921 57 29C57 10.0079 47.9921 1 29 1Z" fill={colors.background.dark} stroke={colors.borders.divider} stroke-width="1.4"/>
      </Svg>
      <Svg width={Number(width) * 0.83} height={Number(height) * 0.83} viewBox="0 0 48 48" fill="none" style={styles.innerIcon}>
        <Path d="M23.9344 -6.10352e-05C7.69994 -6.10352e-05 0 7.69988 0 23.9343C0 40.1687 7.69994 47.8687 23.9344 47.8687C40.1688 47.8687 47.8687 40.1687 47.8687 23.9343C47.8687 7.69988 40.1688 -6.10352e-05 23.9344 -6.10352e-05Z" fill="url(#paint0_linear_8834_13347)"/>
        <Path d="M37.4952 20.4911L39.5222 10.2745L29.3055 12.3014L12.8145 32.8449L16.9518 36.9822L37.4952 20.4911Z" fill="white"/>
        <Path d="M14.8418 34.8723L16.9518 36.9822L37.4952 20.4911L39.5222 10.2745L14.8418 34.8723Z" fill="#F2F6FC"/>
        <Path d="M14.1131 31.8928L17.9038 35.6834L11.869 41.7182L8.07837 37.9275L14.1131 31.8928Z" fill="#F8A122"/>
        <Path d="M9.93213 39.7814L15.9669 33.7466L17.9035 35.6833L11.8687 41.718L9.93213 39.7814Z" fill="#FF4E2A"/>
        <Path d="M13.5538 29.0825L20.7139 36.2426L18.4636 38.4934L11.3035 31.3332L13.5538 29.0825Z" fill="#FFE000"/>
        <Path d="M14.8416 34.8722L17.0919 32.6215L20.7134 36.2431L18.4627 38.4934L14.8416 34.8722Z" fill="#FFC200"/>
        <Defs>
          <LinearGradient id="paint0_linear_8834_13347" x1="33.1764" y1="47.8687" x2="-51.3362" y2="-17.1031" gradientUnits="userSpaceOnUse">
            <Stop stopColor={colors.gradients.darkPurple.colors[0]}/>
            <Stop offset="1" stopColor={colors.gradients.darkPurple.colors[1]}/>
          </LinearGradient>
        </Defs>
      </Svg>
      {/* <Svg
                width="33"
                height="33"
                viewBox="0 0 58 58"
                fill="none"
                style={{ position: 'absolute' }}
              >
               <Path
                  d="M1 1C22.027 1 32 10.973 32 32"
                  stroke={Colors.primary}
                  strokeWidth="1.47619"
                  strokeLinecap="round"
                /> */}
      {/* <Defs>
                  <LinearGradient
                    id="paint0_linear_10763_22655"
                    x1="22.4851"
                    y1="32"
                    x2="-32.2456"
                    y2="-10.076"
                    gradientUnits="userSpaceOnUse"
                  >
                    <Stop stopColor="#6C38FF" />
                    <Stop offset="1" stop-color="#8F67FF" />
                  </LinearGradient>
                </Defs>
              </Svg> */}
    </View>);
};
const styles = StyleSheet.create({
    innerIcon: {
        position: 'absolute',
        right: rem(5),
        bottom: rem(5),
    },
});
export default QuestsProgressIcon;
